"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const usehooks_ts_1 = require("usehooks-ts");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const ton_1 = require("@ton/ton");
const wallet_1 = require("../../logic/wallet");
const swap_module_css_1 = __importDefault(require("./swap.module.css"));
const amounts_1 = require("./amounts");
const checkpsw_1 = require("./checkpsw");
const swapcheck_1 = require("./swapcheck");
const dedust_api_1 = require("../../logic/dedust-api");
const selectAsset_1 = require("./selectAsset");
const tonapi_1 = require("../../logic/tonapi");
const stores_1 = require("../../stores");
const getClient_1 = require("../../utils/getClient");
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const SwapPage = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { storeMain } = (0, stores_1.useStores)();
    const TgObj = sdk_1.default;
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const [position, setPosition] = (0, react_1.useState)(0);
    const [isSwapped, setIsSwapped] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dedustapi = new dedust_api_1.DedustApi();
    const tonApi = new tonapi_1.TonApi();
    const [availableAssets, setAvailableAssets] = (0, react_1.useState)(undefined);
    const [dedustOptions, setDedustOptions] = (0, react_1.useState)(undefined);
    const [assetsLoading, setAssetsLoading] = (0, react_1.useState)(false);
    const [isFromAssets, setIsFromAssets] = (0, react_1.useState)(true);
    const [deWalletTonFee, setDeWalletTonFee] = (0, react_1.useState)(0); // 1% fron swap in amount
    console.log('deWalletTonFeedeWalletTonFeedeWalletTonFee', deWalletTonFee);
    (0, react_1.useLayoutEffect)(() => {
        const checkPincode = async () => {
            const isPinCode = await wall.isPincodPassword();
            if (!isPinCode) {
                navigate('/changepsw');
            }
        };
        checkPincode();
    });
    const handleBack = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        setPosition(0);
    };
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        setIsSwapped(false);
        props.setShowJettonDetail(false);
        storeMain.setShowNavigation(true);
        navigate('/');
        // props.psw.reset(true, true)
        TgObj.MainButton.hide();
        TgObj.BackButton.hide();
    };
    if (!props.tokensData) {
        window.location.pathname = '/';
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    const [token1, setToken1] = (0, react_1.useState)(props.tokensData[0]);
    const [tokenBalance1, setTokenBalance1] = (0, react_1.useState)('');
    const [token2, setToken2] = (0, react_1.useState)(props.tokenSwap || props.tokensData[1]);
    const [tokenBalance2, setTokenBalance2] = (0, react_1.useState)('');
    const [isValidAmount, setIsValidAmount] = (0, react_1.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        window.document.body.scrollTo(0, 0);
    }, []);
    (0, react_1.useEffect)(() => {
        if (isModalOpen) {
            window.document.body.style.overflow = 'hidden';
        }
        return () => {
            window.document.body.style.overflow = 'auto';
        };
    }, [isModalOpen]);
    const handleSwitch = () => {
        setTokenBalance1(tokenBalance2);
        setTokenBalance2('');
        setToken1(token2);
        setToken2(token1);
    };
    console.log(token1);
    console.log(token2);
    const [estimateLoading, setEstimateLoading] = (0, react_1.useState)(false);
    const debouncedTokenBalance1 = (0, usehooks_ts_1.useDebounce)(tokenBalance1, 500);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            try {
                setEstimateLoading(true);
                setTokenBalance2('0.00');
                if (((token1.token === 'DEANON' || token2.token === 'DEANON') && (token1.token === 'DFC' || token2.token === 'DFC'))
                    || ((token1.token === 'PRIVATE' || token2.token === 'PRIVATE') && (token1.token === 'DFC' || token2.token === 'DFC'))) {
                    console.log("PRIVATE ESTIMATE");
                    const tokenEstimatedBalance = await wall.GetEstimatedWithoutRouting(token1.token, token2.token, debouncedTokenBalance1, token1.tokenAddress[0], token2.tokenAddress[0], token1.decimals ?? 9, token2.decimals ?? 9);
                    setTokenBalance2(tokenEstimatedBalance);
                    setDeWalletTonFee(0.5);
                }
                else {
                    const tokenEstimatedBalance = await wall.GetEstimatedSwapOut(token1.token, token2.token, debouncedTokenBalance1, token1.tokenAddress[0], token2.tokenAddress[0], token1.decimals ?? 9, token2.decimals ?? 9);
                    setTokenBalance2(tokenEstimatedBalance);
                }
                if (token1.token === 'TON') {
                    setDeWalletTonFee(Number(tokenBalance1) * 0.01);
                }
                else if (token1.token !== 'TON') {
                    if (token1.token === 'DEANON' || token1.token === 'PRIVATE') {
                        setDeWalletTonFee(0.5);
                    }
                    else {
                        const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                        const tonData = dedustOptions?.find(element => element.token === 'TON');
                        const tonFee = UsdFee / Number(tonData?.priceUSD);
                        setDeWalletTonFee(tonFee);
                    }
                }
                setEstimateLoading(false);
            }
            catch (error) {
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                setEstimateLoading(true);
                setTokenBalance2('0.00');
                if (((token1.token === 'DEANON' || token2.token === 'DEANON') && (token1.token === 'DFC' || token2.token === 'DFC'))
                    || ((token1.token === 'PRIVATE' || token2.token === 'PRIVATE') && (token1.token === 'DFC' || token2.token === 'DFC'))) {
                    const tokenEstimatedBalance = await wall2.GetEstimatedWithoutRouting(token1.token, token2.token, debouncedTokenBalance1, token1.tokenAddress[0], token2.tokenAddress[0], token1.decimals ?? 9, token2.decimals ?? 9);
                    setTokenBalance2(tokenEstimatedBalance);
                    setDeWalletTonFee(0.1);
                }
                else {
                    const tokenEstimatedBalance = await wall2.GetEstimatedSwapOut(token1.token, token2.token, debouncedTokenBalance1, token1.tokenAddress[0], token2.tokenAddress[0], token1.decimals ?? 9, token2.decimals ?? 9);
                    setTokenBalance2(tokenEstimatedBalance);
                }
                if (token1.token === 'TON') {
                    setDeWalletTonFee(Number(tokenBalance1) * 0.01);
                }
                else if (token1.token !== 'TON') {
                    if (token1.token === 'DEANON' || token1.token === 'PRIVATE') {
                        setDeWalletTonFee(0.5);
                    }
                    else {
                        const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                        const tonData = dedustOptions?.find(element => element.token === 'TON');
                        const tonFee = UsdFee / Number(tonData?.priceUSD);
                        setDeWalletTonFee(tonFee);
                    }
                }
                setEstimateLoading(false);
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 15000);
        return () => clearInterval(intervalId);
    }, [token1, token2, debouncedTokenBalance1]);
    async function swapMakeToCompl() {
        if (token1.token === token2.token) {
            TgObj.showAlert('Same tokens');
            setIsSwapped(false);
            return;
        }
        //PRIVATE
        props.setIsSwapSuccess(false);
        if (((token1.token === 'DEANON' || token2.token === 'DEANON') && (token1.token === 'DFC' || token2.token === 'DFC'))
            || ((token1.token === 'PRIVATE' || token2.token === 'PRIVATE') && (token1.token === 'DFC' || token2.token === 'DFC'))) {
            // SwapJettonsWithoutRouting
            console.log("DEANON SWAP");
            try {
                setIsSwapped(true);
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                if (typeof checkPsw === 'object') {
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSwapped(false);
                    return;
                }
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const tonFeeToStakan = (0, ton_1.toNano)(0);
                let finalFee = tonFee;
                if (token1.token === 'DEANON' || token1.token === 'PRIVATE') {
                    finalFee = tonFeeToStakan;
                }
                const swap = await wall.SwapJettonsWithoutRouting(props.psw.value, token1.tokenAddress[0], token2.tokenAddress[0], tokenBalance1, finalFee, token1.decimals ?? 9);
                console.log('token1.tokenAddress[0]', token1.tokenAddress[0]);
                console.log('swap jetton to ton', swap);
                if (!swap) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
            }
            catch (error) {
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const tonFeeToStakan = (0, ton_1.toNano)(0);
                let finalFee = tonFee;
                if (token1.token === 'DEANON' || token1.token === 'PRIVATE') {
                    finalFee = tonFeeToStakan;
                }
                const swap2 = await wall2.SwapJettonsWithoutRouting(props.psw.value, token1.tokenAddress[0], token2.tokenAddress[0], tokenBalance1, finalFee, token1.decimals ?? 9);
                if (!swap2) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
                console.error(error);
                // props.setIsSwapSuccess(false)
                // setPosition(2)
            }
            finally {
                setIsSwapped(false);
                // handleCloseModal()
                setTokenBalance1('0');
                setTokenBalance2('0');
                TgObj.MainButton.hideProgress();
            }
        }
        else if (token1.token === 'TON' && token2.token !== 'TON') {
            try {
                setIsSwapped(true);
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                if (typeof checkPsw === 'object') {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSwapped(false);
                    return;
                }
                if (Number(token1.amount) < 0.5 + Number(tokenBalance1) * 0.01 + Number(tokenBalance1)) {
                    TgObj.showAlert('Insufficient TON amount');
                    setIsSwapped(false);
                    return;
                }
                if (Number(tokenBalance1) < 0.5) {
                    TgObj.showAlert('Insufficient amount');
                    setIsSwapped(false);
                    return;
                }
                const swap = await wall.SwapTonToJetton(props.psw.value, token2.tokenAddress[0], tokenBalance1);
                console.log('swap', swap);
                if (!swap) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
            }
            catch (error) {
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const swap2 = await wall2.SwapTonToJetton(props.psw.value, token2.tokenAddress[0], tokenBalance1);
                if (!swap2) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
                console.error(error);
                // props.setIsSwapSuccess(false)
                // setPosition(2)
            }
            finally {
                // handleCloseModal()
                setIsSwapped(false);
                setTokenBalance1('0');
                setTokenBalance2('0');
                TgObj.MainButton.hideProgress();
            }
        }
        else if (token1.token !== 'TON' && token2.token === 'TON') {
            try {
                setIsSwapped(true);
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                if (typeof checkPsw === 'object') {
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSwapped(false);
                    return;
                }
                if (Number(token2.amount) < 0.5) {
                    TgObj.showAlert('Insufficient TON amount');
                    setIsSwapped(false);
                    return;
                }
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const swap = await wall.SwapJettonToTon(props.psw.value, token1.tokenAddress[0], tokenBalance1, tonFee, token1.decimals ?? 9);
                console.log('token1.tokenAddress[0]', token1.tokenAddress[0]);
                console.log('swap jetton to ton', swap);
                if (!swap) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
            }
            catch (error) {
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01;
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const swap2 = await wall2.SwapJettonToTon(props.psw.value, token1.tokenAddress[0], tokenBalance1, tonFee, token1.decimals ?? 9);
                if (!swap2) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
                console.error(error);
                // props.setIsSwapSuccess(false)
                // setPosition(2)
            }
            finally {
                setIsSwapped(false);
                // handleCloseModal()
                setTokenBalance1('0');
                setTokenBalance2('0');
                TgObj.MainButton.hideProgress();
            }
        }
        else if (token1.token !== 'TON' && token2.token !== 'TON') {
            try {
                setIsSwapped(true);
                const checkPsw = await wall.getPrivateKey(props.psw.value);
                // eslint-disable-next-line @typescript-eslint/quotes
                console.log('props.psw.value', props.psw.value);
                if (typeof checkPsw === 'object') {
                    // eslint-disable-next-line no-alert
                    TgObj.showAlert(t('common.incorrect-password'));
                    setIsSwapped(false);
                    return;
                }
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                if (Number(tonData?.amount) < 0.5) {
                    TgObj.showAlert('Insufficient TON amount');
                    setIsSwapped(false);
                    return;
                }
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01; // 1% fee
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const swap = await wall.SwapJettonToJetton(props.psw.value, token1.tokenAddress[0], token2.tokenAddress[0], tokenBalance1, tonFee, token1.decimals ?? 9);
                if (!swap) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
            }
            catch (error) {
                const wall2 = new wallet_1.CustomWallet((0, getClient_1.getHubClient)());
                const tonData = dedustOptions?.find(element => element.token === 'TON');
                const UsdFee = Number(tokenBalance1) * Number(token1.priceUSD) * 0.01; // 1% fee
                const tonFee = (0, ton_1.toNano)(UsdFee / Number(tonData?.priceUSD));
                const swap2 = await wall2.SwapJettonToJetton(props.psw.value, token1.tokenAddress[0], token2.tokenAddress[0], tokenBalance1, tonFee, token1.decimals ?? 9);
                if (!swap2) {
                    props.setIsSwapSuccess(false);
                    setPosition(2);
                }
                else {
                    props.setIsSwapSuccess(true);
                    setPosition(2);
                }
                console.error(error);
                // props.setIsSwapSuccess(false)
                // setPosition(2)
            }
            finally {
                setIsSwapped(false);
                // handleCloseModal()
                setTokenBalance1('0');
                setTokenBalance2('0');
                TgObj.MainButton.hideProgress();
            }
        }
    }
    //= ======================= change assets logic
    async function getAssets() {
        try {
            setAssetsLoading(true);
            const assets = await dedustapi.getAssets();
            console.log('DEDUST assets');
            console.log(assets);
            if (!assets) {
                return;
            }
            setAvailableAssets(assets);
        }
        catch (error) {
            console.error('Error fetching transactions:', error);
        }
        finally {
            setAssetsLoading(false);
        }
    }
    (0, react_1.useEffect)(() => {
        getAssets();
    }, []);
    async function getOptions() {
        try {
            console.log('availableAssets', availableAssets);
            console.log('props.tokensData', props.tokensData);
            if (availableAssets !== undefined) {
                const parsedOptions = availableAssets.map(asset => ({
                    token: asset.symbol,
                    name: asset.name,
                    tokenLogo: asset.image,
                    amount: '0',
                    amountUSD: '0',
                    priceUSD: '0',
                    changePrice: '0',
                    decimals: asset.decimals,
                    tokenAddress: asset.address
                        ? [asset.address]
                        : [
                            '0:9a8da514d575d20234c3fb1395ee9138f5f1ad838abc905dc42c2389b46bd015',
                            '0:436b4ff60f7bacf75f70d422cfb6b5ae7cd2846f0f3553ae8bcc798258923608'
                        ] // for Ton
                }));
                // add XMOON or DEANON
                const additionalTokens = [
                    {
                        token: 'DEANON',
                        name: 'DEANON',
                        tokenLogo: `https://cache.tonapi.io/imgproxy/C9ydS_DmPndKyy8IgQgGw8_ZHTC6k1A8Nfw1p3px9Us/rs:fill:200:200:1/g:no/aHR0cHM6Ly9pLmliYi5jby9Ua0JEQ2RyLzBhMTcwODUwLTNhMmMtNDA4MC1iODA4LTIwMmI3NWI1MDgxOC5qcGc.webp`,
                        amount: '0',
                        amountUSD: '0',
                        priceUSD: '0',
                        changePrice: '0',
                        decimals: 9,
                        tokenAddress: ['EQBTUH6cdozp2TWujAqamNjgmCrXcV7FraQ6KieDu7pYsMjm']
                    },
                    {
                        token: 'PRIVATE',
                        name: 'Private Coin',
                        tokenLogo: `https://cache.tonapi.io/imgproxy/WYSiMdPjsGKj_WfqqXauvTk6aSkgSbosZfllaxbfais/rs:fill:200:200:1/g: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.webp`,
                        amount: '0',
                        amountUSD: '0',
                        priceUSD: '0',
                        changePrice: '0',
                        decimals: 9,
                        tokenAddress: ['EQA3BC27XNeinlQFvvQQipMEoTLupUshAkSVb0W129TH_OIf']
                    },
                    {
                        token: 'USD₮',
                        name: 'Tether USD',
                        tokenLogo: `https://cache.tonapi.io/imgproxy/T3PB4s7oprNVaJkwqbGg54nexKE0zzKhcrPv8jcWYzU/rs:fill:200:200:1/g:no/aHR0cHM6Ly90ZXRoZXIudG8vaW1hZ2VzL2xvZ29DaXJjbGUucG5n.webp`,
                        amount: '0',
                        amountUSD: '0',
                        priceUSD: '0',
                        changePrice: '0',
                        decimals: 6,
                        tokenAddress: ['EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs']
                    }
                ];
                const withAddArray = [...parsedOptions, ...additionalTokens];
                const updatedOptions = withAddArray.map((parsedOption) => {
                    // const priceRes = await tonApi.getTokenPrice(parsedOption.tokenAddress[0], 'usd')
                    const matchingOption = props.tokensData?.find(opt => opt.token === parsedOption.token
                        || opt.token === parsedOption.name
                        || opt.tokenAddress[0] === parsedOption.tokenAddress[0]);
                    if (matchingOption) {
                        return {
                            ...parsedOption,
                            amount: matchingOption.amount,
                            amountUSD: matchingOption.amountUSD
                        };
                    }
                    return parsedOption;
                });
                //========================================================================================================================================================
                const chunkSize = 100;
                const pricesRes = {};
                // console.log('updatedOptions', updatedOptions)
                for (let i = 0; i < updatedOptions.length; i += chunkSize) {
                    const chunk = updatedOptions.slice(i, i + chunkSize);
                    const tokenAddressesString = chunk
                        .map((option) => {
                        if (option.tokenAddress[0]
                            === '0:9a8da514d575d20234c3fb1395ee9138f5f1ad838abc905dc42c2389b46bd015'
                            || option.tokenAddress[1]
                                === '0:436b4ff60f7bacf75f70d422cfb6b5ae7cd2846f0f3553ae8bcc798258923608') {
                            return 'ton';
                        }
                        return option.tokenAddress[0];
                    })
                        .join(',');
                    const chunkPricesRes = await tonApi.getTokenPrice(tokenAddressesString, 'usd');
                    Object.assign(pricesRes, chunkPricesRes?.rates);
                }
                const updatedOptionsWithUsd = updatedOptions.map((parsedOption) => {
                    if (pricesRes) {
                        console.log('pricesRes', pricesRes);
                        return {
                            ...parsedOption,
                            priceUSD: pricesRes[parsedOption.tokenAddress[0]]?.prices.USD
                                // @ts-ignore
                                ?? pricesRes?.TON?.prices.USD
                                ?? '',
                            changePrice: pricesRes[parsedOption.tokenAddress[0]]?.diff_24h.USD
                                // @ts-ignore
                                ?? pricesRes?.TON?.diff_24h.USD
                                ?? ''
                        };
                    }
                    return parsedOption;
                });
                //========================================================================================================================================================
                // 000
                const valuesToExclude = [
                    'jUSDC',
                    'jDAI',
                    'jUSDC',
                    'jWBTC',
                    'oUSDC',
                    'oWBTC',
                    'oDAI',
                    'stTON',
                    'wsTON',
                    'FCK',
                    'SENRG'
                ];
                const filteredOptions = updatedOptionsWithUsd.filter(option => !valuesToExclude.includes(option.token));
                setDedustOptions(filteredOptions);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    (0, react_1.useEffect)(() => {
        getOptions();
    }, [availableAssets, props.tokensData]);
    console.log('dedustOptions', dedustOptions);
    (0, react_1.useEffect)(() => {
        if (dedustOptions) {
            setToken1(dedustOptions[0]);
            if (!props.tokenSwap) {
                const foundOption = dedustOptions.find(option => option.token === 'DFC');
                if (foundOption) {
                    setToken2(foundOption);
                }
                else
                    setToken2(dedustOptions[1]);
            }
        }
    }, []);
    //= ====================
    (0, react_1.useEffect)(() => {
        if (position === 1) {
            storeMain.setShowNavigation(false);
        }
        else if (position !== 1) {
            storeMain.setShowNavigation(true);
        }
    }, [position]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${swap_module_css_1.default.wrapper} ${position === 1 ? '' : swap_module_css_1.default.wrapperPadding}`, children: [position === 0 && ((0, jsx_runtime_1.jsx)(amounts_1.Amounts, { tokensData: props.tokensData, dedustOptions: dedustOptions, token1: token1, setToken1: setToken1, token2: token2, setToken2: setToken2, tokenBalance1: tokenBalance1, setTokenBalance1: setTokenBalance1, tokenBalance2: tokenBalance2, setTokenBalance2: setTokenBalance2, isValidAmount: isValidAmount, setIsValidAmount: setIsValidAmount, handleSwitch: handleSwitch, isTg: props.isTg, setPosition: setPosition, position: position, isModalOpen: isModalOpen, setIsModalOpen: setIsModalOpen, setIsFromAssets: setIsFromAssets, isFromAsset: isFromAssets, handleCloseModal: handleCloseModal, estimateLoading: estimateLoading, setEstimateLoading: setEstimateLoading, deWalletTonFee: deWalletTonFee })), position === 1 && ((0, jsx_runtime_1.jsx)(checkpsw_1.CheckPsw, { isTg: props.isTg, tokenBalance1: tokenBalance1, psw: props.psw, swapMakeToCompl: swapMakeToCompl, isSwapped: isSwapped, position: position, handleBack: handleBack })), position === 2 && ((0, jsx_runtime_1.jsx)(swapcheck_1.SwapCheck, { isTg: props.isTg, isSwapSuccess: props.isSwapSuccess, position: position, addressUser: props.addressUser, handleCloseModal: handleCloseModal, psw: props.psw })), isModalOpen && ((0, jsx_runtime_1.jsx)(selectAsset_1.SelectAsset, { tokensData: isFromAssets
                    ? dedustOptions?.filter(el => !el.token.toLowerCase().includes(token2.token.toLowerCase()))
                    : dedustOptions?.filter(el => !el.token.toLowerCase().includes(token1.token.toLowerCase())), swapData: isFromAssets ? token1 : token2, setSwapData: isFromAssets ? setToken1 : setToken2, closeModal: () => {
                    TgObj.HapticFeedback.impactOccurred('medium');
                    setIsModalOpen(false);
                }, setIsModalOpen: setIsModalOpen, isModalOpen: isModalOpen }))] }));
};
exports.SwapPage = SwapPage;
